module.exports = __webpack_public_path__ + "img/tiff.046c554e.png";